import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import { useTranslation } from '@hooks';
import { alertActions } from '@actions/alert';
import { micrositesService } from '@services';
import DnsRecordCard from '@components/DnsRecordCard';
import DomainCheckStatus from '@components/DomainCheckStatus';

const Content = styled('div')({
    padding: '16px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
});

const STATUS_LABELS_KEYS = {
    0: 'MicrositesPage.statusPending',
    1: 'MicrositesPage.statusActive',
    2: 'MicrositesPage.statusFailed',
};

const DomainDetails = ({ domain, onDomainUpdated }) => {
    const { t } = useTranslation();
    const [checking, setChecking] = useState(false);
    const dispatch = useDispatch();

    if (!domain) return null;

    const micrositeCount = domain.microsites?.length || 0;

    const handleCheckStatus = async () => {
        setChecking(true);
        try {
            const updated = await micrositesService.verifyCustomDomainDns(domain.id);
            onDomainUpdated(updated);
        } catch (err) {
            dispatch(alertActions.error(err?.message || t('MicrositesPage.checkStatusError')));
        } finally {
            setChecking(false);
        }
    };

    return (
        <Content>
            <Typography variant="body2" sx={{ color: 'var(--text-secondary)' }}>
                {t('MicrositesPage.dnsInstructions')}
            </Typography>

            <DnsRecordCard name={domain.hostname} value={domain.cnameTarget} />

            <DomainCheckStatus
                status={domain.status}
                statusLabel={t(STATUS_LABELS_KEYS[domain.status]) || 'Unknown'}
                lastCheckedAt={domain.lastCheckedAt}
                error={domain.lastCheckError}
                checking={checking}
                onCheck={handleCheckStatus}
                extraRows={[{ label: t('MicrositesPage.micrositesUsingDomain'), value: micrositeCount }]}
            />
        </Content>
    );
};

export default DomainDetails;
